export default __webpack_public_path__ + "static/media/imen.f5cb387e.png";